import React from 'react';
import { get } from 'lodash';
import TitleSkeleton from '../elements/TitleSkeleton';
import ParagraphSkeleton from '../elements/ParagraphSkeleton';

import './LocationCardSkeleton.scss';

const LocationCardSkeleton = ({ isLoading, children, lines, lineVariant, cards }) => {
  const cardsArray = new Array(cards).fill('');
  return isLoading
    ? cardsArray.map((c, index) => (
        <div className="width-100" key={get(crypto, 'randomUUID()', index)}>
          <TitleSkeleton isLoading={isLoading} />
          <ParagraphSkeleton isLoading={isLoading} lines={lines} lineVariant={lineVariant} />
          {cardsArray.length - 1 > index && <div className="divider" />}
        </div>
      ))
    : children;
};

LocationCardSkeleton.defaultProps = {
  lines: [{}],
};

export default LocationCardSkeleton;
